import { render } from "./SupplierTransactions.vue?vue&type=template&id=8c4c9c8a"
import script from "./SupplierTransactions.vue?vue&type=script&lang=js"
export * from "./SupplierTransactions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__